import locationsEffects from 'domains/locations/effects';
// import emailTemplatesEffects from '@/domains/email_templates/effects';

export default [
  ...locationsEffects,
  // ...emailTemplatesEffects,
];
